import { Dictionary, GoogleTagConfig } from '@common/util-models';

export interface SkyGoogleTagConfig extends GoogleTagConfig {
  selectSkyBoxCTA: Dictionary<string>;
  selectDeviceCategory: Dictionary<string>;
  addDeviceCTA: Dictionary<string>;
  basketLandingTags: Dictionary<string>;
  productCheckoutData: Dictionary<string>;
  checkoutSummaryCTA: Dictionary<string>;
  addLaterCTA: Dictionary<string>;
}

export type LTEnumType = 'Opt-in' | 'Opt-out';
export const LTEnum = {
  OptIn: 'Opt-in' as LTEnumType,
  OptOut: 'Opt-out' as LTEnumType,
};
export interface EcommerceProduct {
  id: string;
  title: string;
  name: string;
  price: number;
  brand: string;
  category: string;
  quantity: number;
  purchaseMonth: number;
  purchaseYear: number;
  purchasePrice: number;
  lt: LTEnumType | null;
  ltPrice: number | null;
}
